import React, { useMemo } from 'react';
import { getLineTotalConIgvHint, getPriceIgvHint } from '../../utils/priceIgvUtils';

const PriceIgvHint = ({
  netPrice = 0,
  igvRate = 18,
  hasIgv = true,
  pricesIncludeIgv = false,
  alwaysConIgv = false,
}) => {
  const hint = useMemo(
    () =>
      alwaysConIgv
        ? getLineTotalConIgvHint(netPrice, { hasIgv, igvRate })
        : getPriceIgvHint(netPrice, {
            pricesIncludeIgv,
            hasIgv,
            igvRate,
          }),
    [netPrice, pricesIncludeIgv, hasIgv, igvRate, alwaysConIgv],
  );

  if (!hint) return null;

  return (
    <span className="block text-teal-700 leading-tight" title={hint.text}>
      {hint.text}
    </span>
  );
};

export default PriceIgvHint;
